import { Component, Input, OnInit } from '@angular/core';
import { AssessScreenService } from '../../../../shared/services/assessScreen.service';
import { IAssessScreen } from '../../../../shared/models/assessScreen';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { EYesNo } from '../../../../shared/models/types.enum';

@Component({
  selector: 'review-assess-screen',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-assess-screen.component.html',
  styleUrl: './review-assess-screen.component.css'
})
export class ReviewAssessScreenComponent implements OnInit {

  @Input() caseId: string | null = null;

  yesNo = EYesNo;
  assessScreen: any = {};
  loading: boolean = false;

  sections = [
    {
      sectionName: "Threat Assessment Situation",
      children: [
        {
          type: 'string',
          questionText: "Threat Assessment Situation:",
          answer: "detail_of_situation"
        },
        {
          type: 'date',
          questionText: "Date of Accident:",
          answer: "date_of_incident"
        },
        {
          type: 'string',
          questionText: "Time of Accident:",
          answer: "time_of_incident"
        },
        {
          type: 'number',
          questionText: "Did the incident occur on campus?",
          answer: "incident_on_campus"
        },
        {
          type: 'string',
          questionText: "Location of Incident:",
          answer: "incident_location"
        }
      ]
    },
    {
      sectionName: "Additional Information",
      children: [
        {
          type: 'number',
          questionText: "Do we understand the student's motives and goals?",
          answer: "student_goal_understanding",
        },
        {
          type: 'number',
          questionText: "Have there been any communications suggesting ideas or intent to attack?",
          answer: "student_communications",
        },
        {
          type: 'number',
          questionText: "Has the student shown inappropriate/concerning interest in school attacks or attackers, weapons, or incidents of mass violence?",
          answer: "mass_violence",
        },
        {
          type: 'number',
          questionText: "Does the student have the capacity (resources or ability) to carry out the act?",
          answer: "means_for_attack",
        },
        {
          type: 'number',
          questionText: "Has the student displayed stressors such as setbacks, losses, and other challenges?",
          answer: "stressful_events",
        },
        {
          type: 'number',
          questionText: "Has the student experienced feelings related to a diagnosable mental illness, such as depression?",
          answer: "student_mental_illness",
        },
        {
          type: 'number',
          questionText: "Is the student experiencing hopelessness, desperation, or despair?",
          answer: "hopelessness_desparation",
        },
        {
          type: 'number',
          questionText: "Does the student see violence as an acceptable or desirable way to solve problems?",
          answer: "acceptable_violence",
        },
        {
          type: 'number',
          questionText: "Are other people concerned about the individual's potential for violence?",
          answer: "potential_violence",
        },
        {
          type: 'number',
          questionText: "Is the student's thinking and behaviors organized enough to plan and execute an attack?",
          answer: "organized_behaviors",
        },
        {
          type: 'number',
          questionText: "Corroborate the student's statement. Is the student's conversation and 'story' consistent with their actions?",
          answer: "story_fabrication",
        },
        {
          type: 'number',
          questionText: "Does the student have a positive, trusting relationship with an adult at school?",
          answer: "positive_relationship_adult",
        },
        {
          type: 'string',
          questionText: "Describe additional circumstances that might increase the likelihood of violence like home stressors: (domestic violence, incarcerated family member, etc.)",
          answer: "stressful_events_information",
        },
        {
          type: 'string',
          questionText: "Home stressors (What are some of the potential home stressors)?",
          answer: "home_stressors_information",
        }
      ]
    },
    {
      sectionName: "Required Assessments",
      children: [
        {
          type: 'number',
          questionText: "Does the incident warrant the completion of a suicide assessment in addition to or instead of a threat assessment?",
          answer: "suicide_risk_assessment",
        },
        {
          type: 'string',
          questionText: "By Whom:",
          answer: "suicide_risk_assessment_person",
        },
        {
          type: 'date',
          questionText: "When:",
          answer: "suicide_risk_assessment_date",
        },
        {
          type: 'number',
          questionText: "Does this incident warrant the completion of a Full Team Threat Assessment as determined by at least two members of your behavioral threat assessment team?",
          answer: "full_team_threat_assessment",
          specialOptions: {
            1: "Continue to Full Team Threat Assessment",
            0: "Develop a Response, Management and Support Plan and complete Summary Documentation Form"
          }
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "user_signature_date_time"
        }
      ]
    }
  ]

  constructor(
    private assessScreenService: AssessScreenService
  ) { }

  ngOnInit(): void {
    this.loadAssessScreen();
  }

  loadAssessScreen(): void {
    if (this.caseId) {
      this.loading = true;      
      this.assessScreenService.getAssessScreenByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.assessScreen = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching assess screen:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
